import React from 'react';
import { StyledHeader } from '../../styles/devices/Calendar'

export let Header = ({ label }) => {
  
    return (
        <StyledHeader>
          {label.split(' ')[1]}
        </StyledHeader>
    )
}

export let Toolbar = ({ onView, label, views }) => {
  
    return (
        <div></div>
    )
}

